<template>
  <div class="be-room-card__col be-room-card__col--room">
    <template v-if="isSelectable">
      <div class="be-room-card__qty-wrap">
        <button type="button" class="be-room-card__qty-trigger be-press" @click="isOpen = !isOpen">
          <span>{{ selectedQty }}</span>
          <ChevronDown :size="12" />
        </button>
        <div v-if="isOpen" class="be-room-card__qty-backdrop" @click="isOpen = false"></div>
        <transition name="be-pop-down-center">
          <div v-if="isOpen" class="be-room-card__qty-menu">
            <div
              class="be-room-card__qty-option"
              v-for="option in qtyOptionItems"
              :key="option.value"
              @click="selectQty(option.value)">
              {{ option.label }}
            </div>
            <div
              v-if="hasMoreQtyOptions"
              class="be-room-card__qty-option"
              @click="openQtyModal">
              {{ $t('hotel.unit-type.' + type.type + '.more-unit-label') }}
            </div>
          </div>
        </transition>
      </div>
      <p v-if="showRoomsLeft" class="be-room-card__rooms-left">{{ roomLeftText }}</p>
    </template>
    <span v-else class="be-room-card__dash">—</span>
  </div>
</template>

<script>
  import { ChevronDown } from 'lucide-vue';

  const QTY_DROPDOWN_LIMIT = 5;

  export default {
    name: 'RoomCardRateQty',
    components: {
      ChevronDown
    },
    props: {
      rate: {
        type: Object,
        default: () => ({})
      },
      type: {
        type: Object,
        default: () => ({})
      },
      avail: {
        type: Number,
        default: 0
      },
      maxQty: {
        type: Number,
        default: 1
      },
      selectedQty: {
        type: Number,
        default: 1
      },
      showRoomsLeft: {
        type: Boolean,
        default: false
      },
      roomLeftText: {
        type: String,
        default: ''
      }
    },
    data(){
      return {
        isOpen: false
      }
    },
    computed: {
      isSelectable(){
        return this.rate.bookable && this.avail > 0;
      },
      qtyOptionItems(){
        const cap = Math.min(this.maxQty, QTY_DROPDOWN_LIMIT);
        const options = [];
        for(let qty = 1; qty <= cap; qty++){
          options.push({ value: qty, label: `${qty} ${this.printUnitWord(qty)}` });
        }
        return options;
      },
      hasMoreQtyOptions(){
        return this.maxQty > QTY_DROPDOWN_LIMIT;
      }
    },
    methods: {
      printUnitWord(qty){
        const form = qty > 1 ? 'units' : 'unit';
        return this.$t('hotel.unit-type.' + this.type.type + '.' + form);
      },
      selectQty(qty){
        this.isOpen = false;
        this.$emit('select', qty);
      },
      openQtyModal(){
        this.isOpen = false;
        this.$emit('open-modal');
      }
    }
  }
</script>

<style scoped>
.be-room-card__qty-wrap {
  position: relative;
  display: inline-block;
}
.be-room-card__qty-trigger {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 12px;
  border: 1px solid var(--be-v3-border, #d5d9e0);
  border-radius: var(--be-v3-button-radius, 14px);
  font-size: var(--be-v3-text-secondary, 0.8125rem);
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  color: #1a1a2e;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  cursor: pointer;
}
.be-room-card__qty-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
}
.be-room-card__qty-menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
  min-width: 150px;
  background: #fff;
  border: 1px solid var(--be-v3-border, #d5d9e0);
  border-radius: var(--be-v3-radius, 14px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);
  overflow: hidden;
  z-index: 1041;
}
.be-room-card__qty-option {
  padding: 10px 14px;
  border-bottom: 1px solid var(--be-v3-border-soft, #e3e6eb);
  font-size: var(--be-v3-text-secondary, 0.8125rem);
  color: #1a1a2e;
  text-align: center;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color var(--be-v3-dur-fast, 150ms) var(--be-v3-ease, ease-out);
}
.be-room-card__qty-option:last-child {
  border-bottom: none;
}
.be-room-card__qty-option:hover {
  background: #f6f6f6;
}
.be-room-card__rooms-left {
  color: #c62828;
  font-size: var(--be-v3-text-caption, 0.75rem);
  line-height: 1.35;
  margin: 6px 0 0;
}
.be-room-card__dash {
  color: #bbb;
}
@media screen and (max-width: 991.98px) {
  /* the trigger sits flush right in a half-width cell — a trigger-width anchor would
     push the centred menu past the card edge, so measure it against the whole cell */
  .be-room-card__qty-wrap {
    display: block;
  }
  .be-room-card__qty-menu {
    min-width: 130px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hotel/be/v3/room-card/RoomCardRateQty.vue